import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mt-2" }
const _hoisted_2 = {
  key: 0,
  class: "form-check"
}
const _hoisted_3 = {
  key: 1,
  class: "alert alert-dismissable alert-warning",
  "aria-live": "polite",
  role: "status"
}
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = {
  key: 0,
  class: "mb-2",
  "aria-live": "polite",
  "aria-atomic": "true",
  role: "status"
}
const _hoisted_6 = ["disabled", "aria-busy"]
const _hoisted_7 = {
  ref: "screenDetector",
  style: {"height":"0","width":"0"},
  class: "d-none d-sm-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_VueFileAgent = _resolveComponent("VueFileAgent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_loading_spinner, { "show-loading": _ctx.showUploadingSpinner }, null, 8, ["show-loading"]),
    _createVNode(_component_VueFileAgent, {
      modelValue: _ctx.fileRecords,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileRecords) = $event)),
      ref: "vueFileAgent",
      theme: 'list',
      multiple: true,
      deletable: true,
      sortable: false,
      resumable: false,
      auto: false,
      meta: true,
      accept: _ctx.permittedFileTypeString,
      maxSize: _ctx.maxSize,
      maxFiles: 20,
      helpText: 'Select or drop file(s) here',
      errorText: "We're sorry, but we were unable to upload your file. Please ensure that the file type is a .csv file and that it is less than 10MB in size. If you continue to experience issues, please contact your administrator for further assistance.",
      fileCheckUrl: _ctx.url,
      onSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filesSelected($event))),
      onBeforedelete: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onBeforeDelete($event))),
      onDelete: _cache[3] || (_cache[3] = ($event: any) => (_ctx.fileDeleted($event)))
    }, null, 8, ["modelValue", "accept", "maxSize", "fileCheckUrl"]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component), {
      modelValue: _ctx.data,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.data) = $event))
    }, null, 8, ["modelValue"])),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isAdminOnly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _withDirectives(_createElementVNode("input", {
              id: "adminOnly",
              type: "checkbox",
              class: "form-check-input",
              checked: "false",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.hideFromStdUser) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.hideFromStdUser]
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("label", {
              for: "adminOnly",
              class: "form-check-label"
            }, "Hide From Standard User", -1))
          ]))
        : _createCommentVNode("", true),
      (_ctx.fileRecords.length == 20)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " You can only upload 20 files at a time. Please do another upload for any additional files. "))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.showUploadingSpinner)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("span", {
                class: "spinner-border spinner-border-sm me-2",
                role: "presentation",
                "aria-hidden": "true"
              }, null, -1),
              _createTextVNode(" Uploading files... ", -1)
            ]))]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "btn btn-primary",
          disabled: _ctx.isUploadDisabled || _ctx.showUploadingSpinner,
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.uploadFiles($event))),
          type: "button",
          "aria-busy": _ctx.showUploadingSpinner
        }, " Upload " + _toDisplayString(_ctx.fileRecords.length) + " File(s) ", 9, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, null, 512)
  ]))
}